export default __webpack_public_path__ + "static/media/30.c6fb3cc7.png";